module.exports = "https://www.gc-qa.gnp.com.mx/c8c100af1cea60abae43793859911637.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icono_warning.svg
// module id = 1845
// module chunks = 0